import React from "react";
import "./loader.css"; // Import tệp CSS

const LoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center vh-100">
        <div>
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
);

export default LoadingSpinner;
